export * from "./notification";

export const ROUTES = {
  // Auth
  LANDING: "/",
  COMING_SOON: "/coming-soon",
  SIGN_IN: "/sign-in",
  REGISTER: "/register",
  REGISTER_ORGANIZATION: "/register/organization",
  ORGANIZATION_HOME: "/organization",
  ORGANIZATION_HALL: "/organization/hall",
  ORGANIZATION_LOBBY: "/organization/lobby",
  ORGANIZATION_INVITES: "/organization/invitations",
  FORGOT_PASSWORD: "/forgot-password",
  ADD_USERNAME: "/add-username",
  AUTH_CALLBACK: "/auth/callback",

  // Discovery
  LOBBY: "/lobby",
  USER_HOME: "/user",
  MY_FEED: "/my-feed",
  TALENTS: "/talents",
  HOME: "/home",
  NOTIFICATION: "/notification",
  INBOX: "/inbox",
  AVAILABLE_DECK_COLLECTIONS: "/deck-collections",

  // Limited edition
  LIMITED_EDITION: "/limited-edition/verify/:purchaseId",

  // My Deck
  CHARM: "/charm",
  CHARM_DETAIL: "/charm/:id",
  PERSONAL_CHARM_DETAIL: "/charm/personal/:id",

  // Talent / Hall
  TALENT_HALL: "/talent-hall",
  TALENT_HALL_CARDS: "/talent-hall/talent-cards",
  USER_HALL: "/talent-hall/:id",
  TALENT_HALL_SHELF: "/talent-hall/:id/shelf",
  REGISTER_TALENT: "/register-talent",

  // Cards
  CREATE_CARD: "/create-card",
  APP_CARD_DECK: "/app-deck",
  TALENT_SEASON_CARD_CREATE: "/talent/season-cards/create",
  TALENT_SEASON_CARD_EDIT: "/talent/season-cards/:seasonCardId/edit",
  TALENT_SEASON_CARD_ADD_EXPERIENCE: "/talent/season-cards/:seasonCardId/experiences/add",
  TALENT_SEASON_CARD_EDIT_EXPERIENCE:
    "/talent/season-cards/:seasonCardId/experiences/:experienceId/edit",
  TALENT_SEASON_CARD_SHOWCASE: "/talent/season-cards/showcase",
  SEASON_CARD_SHOWCASE: "/season-card/showcase",
  COLLECTION_CARD_PUBLIC: "/public/collection/:id",

  // Wallet
  WALLET: "/wallet",
  TALENT_WALLET: "/wallet/:id",

  //Settings
  SETTINGS: "/settings",
} as const;

export const STORAGE_KEYS = {
  ACTIVE_TALENT: "ACTIVE_TALENT",
  ACTIVE_ORGANIZATION: "ACTIVE_ORGANIZATION",
  AUTH_TOKEN: "AUTH_TOKEN",
} as const;

export const QUERY_KEYS = {
  USER_PROFILE: "user-profile",
  TALENTS: "talents",
  TALENT_DETAIL: "talent-detail",
  MAIN_CARDS: "main-cards",
  PUBLISHED_CARDS: "published-cards",
  MY_FEED: "my-feed",
  WALLET: "wallet",
} as const;

export const ACCOUNT_TYPES = ["User", "Talent", "Business", "Organization"] as const;

export const USER_TYPES = {
  TALENT: "Talent",
  USER: "User",
  ORGANIZATION: "Organization",
};

/** TN discovery rails — populate when card types are defined */
export type TNSectionConfig = { id: string; label: string; template: string };
export const TN_CARD_SECTIONS: readonly TNSectionConfig[] = [];
